<div class="grid">
    <p-messages [closable]="true" />
    <div class="col-12">
        <div>
            <p-card [header]="'ADD_NEW_INSURANCE_PROVIDER'|translate">
                <div class="p-fluid p-formgrid grid" [formGroup]="providerForm">
                    <form
                        [formGroup]="providerForm"
                        class="field mt-2 col-12 md:col-4 mb-0"
                    >
                        <label htmlFor="firstname" class="text-sm text-500"
                            >{{"PROVIDER_NAME" | translate}}</label
                        >
                        <input
                            type="text"
                            id="firstname"
                           [placeholder]="'PROVIDER_NAME' | translate"
                            pInputText
                            formControlName="name"
                        />
                    </form>
                </div>
                <div
                    class="flex gap-2 mt-2 align-items-end justify-content-start"
                >
                    <form
                        [formGroup]="logoForm"
                        enctype="multipart/form-data"
                        class="flex flex-column"
                    >
                        <small class="text-600 mb-2"
                            >{{'CHOOSE_LOGO' | translate}}</small
                        >
                        <p-fileUpload
                            name="myfile[]"
                            mode="basic"
                            chooseIcon="pi pi-image"
                            uploadIcon="pi pi-image"
                            (onSelect)="onFileSelect($event)"
                            [chooseLabel]="'CHOOSE_LOGO' | translate"
                        >
                        </p-fileUpload>
                    </form>
                </div>
                <hr class="mt-4 mb-0" />
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            (onClick)="back()"
                            [label]="'BACK' | translate"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-save"
                            [label]="'SAVE' | translate"
                            severity="primary"
                            pButton
                            (click)="onSaveSelected()"
                            [disabled]="!providerForm.valid"
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </div>
    </div>
</div>
